document.addEventListener('DOMContentLoaded', async () => {
  const productGrid = document.getElementById('product-grid');
  if (!productGrid || !document.querySelector('.ev-card-variant-wrapper')) {
    //console.info('⏭️ Skipping colour variant filtering — no variant cards found.');
    return;
  }

  const storefrontToken = 'cc5af26be5a3d160e57fae151a66c696';
  const shopDomain = window.Shopify?.shop || window.location.hostname;
  const collectionHandle = window.location.pathname.split('/').pop();

  const query = `
    query GetCollectionWithColorPatterns($collectionHandle: String!, $first: Int!) {
      collection(handle: $collectionHandle) {
        id
        handle
        metafield(namespace: "custom", key: "collection_colours") {
          references(first: $first) {
            nodes {
              ... on Metaobject {
                id
                handle
                fields {
                  key
                  value
                  type
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    collectionHandle,
    first: 100,
  };

  try {
    const response = await fetch(`https://${shopDomain}/api/2024-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    // Raw fallback log
    const raw = await response.text();
    //console.log('📦 Raw GraphQL response:', raw);

    let result = {};
    try {
      result = JSON.parse(raw);
    } catch (err) {
      console.error('❌ Failed to parse JSON response:', err);
      return;
    }

    if (result.errors) {
      console.error('❌ GraphQL response errors:', result.errors);
    }

    if (!result?.data?.collection) {
      console.warn('🚫 Storefront API returned null for collection — possibly excluded from API access.');
      //console.log('🔍 Full API response (parsed):', result);
      return;
    }

    const metaobjects = result?.data?.collection?.metafield?.references?.nodes || [];
    //console.log('🎯 Retrieved metaobjects:', metaobjects);

    const labels = metaobjects
      .map((obj) => {
        const labelField = obj.fields.find((f) => f.key === 'label');
        return labelField?.value?.toLowerCase().trim();
      })
      .filter(Boolean);

    //console.log('✅ Detected Colour Labels:', labels);

    // Reveal only matching variants
    const allCards = document.querySelectorAll('.ev-card-variant-wrapper');
    let count = 0;
    const unmatchedLabels = [];

    allCards.forEach((el) => {

      // GJ20260106: Debugging odd characters in variant references
      /*const raw = el.getAttribute('data-variant-label');
      if (raw && raw.toLowerCase().includes('encore')) {
        console.log('ENCORE CARD DEBUG:', {
          raw,
          rawChars: [...raw].map(c => c.charCodeAt(0)),
        });
      }*/

      const label = el.getAttribute('data-variant-label')?.toLowerCase().trim();
      if (labels.includes(label)) {
        el.classList.remove('hidden');
        count++;
      } else {
        unmatchedLabels.push(label);
      }

      // GJ20260106: Debugging full output of colour variants
      // console.log('API LABELS (raw):', labels);

    });

    if (unmatchedLabels.length > 0) {
      //console.warn('⚠️ Unmatched variant labels on page:', unmatchedLabels);
    }

    // Update product count
    const variantCountDisplay = document.getElementById('variant-count');
    if (variantCountDisplay) variantCountDisplay.textContent = count;
  } catch (err) {
    console.error('❌ GraphQL fetch failed:', err);
  }
});
